import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "../cx";

export type Tone = "accent" | "ok" | "warn" | "danger" | "info";
export function Badge({ tone, tip, className, ...rest }: { tone?: Tone | undefined; tip?: string | undefined } & HTMLAttributes<HTMLSpanElement>) {
  return <span className={cx("sk-badge", tone && `sk-badge--${tone}`, className)} data-sk-tip={tip} {...rest} />;
}
/** Contador de la nav: elementos esperando acción → hot (decisión F6). */
export function Count({ hot, children }: { hot?: boolean | undefined; children: ReactNode }) {
  return <span className={cx("sk-count", hot && "sk-count--hot")}>{children}</span>;
}
export const HotDot = () => <span className="sk-hotdot" />;
